/* eslint-disable no-use-before-define */
import React, { useState } from 'react';
import { useHistory } from "react-router";
import { map, isEmpty } from 'lodash';
import { Accordion, Card, NavDropdown } from 'react-bootstrap';
import onClickOutside from "react-onclickoutside";
import { hideApplicationScroll } from '../../helpers/utilCommon';

const navJSON = [{
    title: "Products and Services",
    subLinks: [{
        title: "Standards & Publications",
        subLinks: [{
            title: "All Standards and Publications",
            link: process.env.REACT_APP_PUB_URL + '/products-services/standards-and-publications.html'
        }, {
            title: "Standards Products",
            link: process.env.REACT_APP_PUB_URL + '/products-services/standards-and-publications/standards.html'
        }, {
            title: "Symposia Papers & STPs",
            link: process.env.REACT_APP_PUB_URL + '/products-services/standards-and-publications/symposia-papers.html'
        }, {
            title: "Manuals, Monographs, & Data Series",
            link: process.env.REACT_APP_PUB_URL + '/products-services/standards-and-publications/mnl.html'
        }, {
            title: "Technical Reports",
            link: process.env.REACT_APP_PUB_URL + '/products-services/standards-and-publications/technical-reports.html'
        }, {
            title: "Journals",
            link: process.env.REACT_APP_PUB_URL + '/products-services/standards-and-publications/journals.html'
        }, {
            title: "Reading Room",
            link: process.env.REACT_APP_PUB_URL + '/products-services/reading-room.html'
        }, {
            title: "Authors",
            link: process.env.REACT_APP_PUB_URL + '/products-services/digital-library.html'
        }]
    }, {
        title: "Book of Standards",
        link: process.env.REACT_APP_PUB_URL + '/products-services/bos.html'
    }, {
        title: "Reading Room",
        link: process.env.REACT_APP_PUB_URL + '/products-services/reading-room.html'
    }, {
        title: "Tracker Services",
        link: process.env.REACT_APP_PUB_URL + '/products-services/tracker-services.html'
    }, {
        title: "Catalogs",
        link: process.env.REACT_APP_PUB_URL + '/products-services/catalogs.html'
    }, {
        title: "Digital Library",
        link: process.env.REACT_APP_PUB_URL + '/products-services/digital-library.html'
    }, {
        title: "Enterprise Solutions",
        subLinks: [{
            title: "Integrated Services",
            link: process.env.REACT_APP_PUB_URL + '/products-services/enterprise-solutions/integrated-services.html'
        }, {
            title: "ASTM Compass®",
            link: process.env.REACT_APP_PUB_URL + '/products-services/enterprise-solutions/astm-compass.html'
        }, {
            title: "SpecBuilder",
            link: process.env.REACT_APP_PUB_URL + '/products-services/enterprise-solutions/specbuilder.html'
        }, {
            title: "Custom Platforms",
            link: process.env.REACT_APP_PUB_URL + '/products-services/enterprise-solutions/custom-platforms.html'
        }]
    }, {
        title: "Proficiency Testing",
        link: process.env.REACT_APP_PUB_URL + '/products-services/proficiency-testing.html'
    }, {
        title: "Training Courses",
        subLinks: [{
            title: "All Training Courses",
            link: process.env.REACT_APP_PUB_URL + '/products-services/training-courses.html'
        }, {
            title: "International Training",
            link: process.env.REACT_APP_PUB_URL + '/products-services/training-courses/international-training.html'
        }, {
            title: "PE Continuing Education",
            link: process.env.REACT_APP_PUB_URL + '/products-services/training-courses/pe-continuing-education.html'
        }, {
            title: "Member and Officer Training",
            link: process.env.REACT_APP_PUB_URL + '/products-services/training-courses/member-training.html'
        }]
    }, {
        title: "Certification",
        link: process.env.REACT_APP_PUB_URL + '/products-services/certification.html'
    }, {
        title: "Cement & Concrete Reference Lab",
        link: process.env.REACT_APP_PUB_CEMENT_REFERENCE_LAB
    }]
}, {
    title: "Get Involved",
    subLinks: [{
        title: "Technical Committees",
        link: process.env.REACT_APP_PUB_URL + '/get-involved/technical-committees.html'
    }, {
        title: "Membership",
        link: process.env.REACT_APP_PUB_URL + '/get-involved/membership.html'
    }, {
        title: "Meetings & Symposia",
        link: process.env.REACT_APP_GLOBAL_MEETING_SYMPOSIA_URL
    }, {
        title: "Students &amp; Professors",
        link: process.env.REACT_APP_PUB_URL + '/get-involved/students-and-professors/for-students/memstudent22.html'
    }, {
        title: "Publish With ASTM",
        link: process.env.REACT_APP_PUB_URL + '/get-involved/publish-with-astm.html'
    }]
}, {
    title: "About",
    subLinks: [{
        title: "Overview",
        subLinks: [{
            title: "Overview",
            link: process.env.REACT_APP_PUB_URL + '/about/overview.html'
        }, {
            title: "Detailed Overview",
            link: process.env.REACT_APP_PUB_URL + '/about/overview/detailed-overview.html'
        }, {
            title: "Fact Sheet",
            link: process.env.REACT_APP_PUB_URL + '/about/overview/fact-sheet.html'
        }, {
            title: "White Papers",
            link: process.env.REACT_APP_PUB_URL + '/about/overview/white-papers.html'
        }, {
            title: "Corporate Citizenship",
            link: process.env.REACT_APP_PUB_URL + '/about/overview/corporate-citizenship.html'
        }]
    }, {
        title: "Governance",
        link: process.env.REACT_APP_PUB_URL + '/about/governance.html'
    }, {
        title: "Global Cooperation Home",
        link: process.env.REACT_APP_PUB_URL + '/about/global-cooperation.html'
    }, {
        title: "President's Column",
        link: process.env.REACT_APP_PUB_SN_LINK + '/?q=presidents-column'
    }, {
        title: "Diversity, Equity, and Inclusion",
        link: process.env.REACT_APP_PUB_URL + '/about/diversity-inclusion.html'
    }]
}, {
    title: "News",
    subLinks: [
        {
            title: "Standardization News",
            link: process.env.REACT_APP_PUB_SN_LINK
        }, {
            title: "News Releases",
            link: process.env.REACT_APP_PUB_NEWSROOM_LINK
        },
    ]
}];

const renderAccordian = (list) => {
    return map(list, (item) => {
        if (!isEmpty(item.subLinks)) {
            return (
                <Card key={item.title} className="astm-card">
                    <Accordion.Toggle as={Card.Header} eventKey={item.title}>
                        <h2 className="mb-0">
                            <button className="btn astm-btn btn-link">
                                {item.title} <i className="fas fa-caret-right astm-icon"></i>
                            </button>
                        </h2>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={item.title}>
                        <Card.Body key={item.title}>
                            <Accordion>
                                {renderAccordian(item.subLinks)}
                            </Accordion>
                        </Card.Body>
                    </Accordion.Collapse>
                </Card>
            );
        }
        return (
            <Card key={item.title} className="astm-card">
                <Accordion.Toggle as={Card.Header} eventKey={item.title}>
                    <h2 className="mb-0">
                        <button className="btn astm-btn btn-link">
                            {item.link && item.link.toLowerCase().indexOf("/myastm") === 0 ? (
                                <a onClick={() => { RenderMobileMenu.handleRedirectWithinMemberApp(item.link); }}>{item.title}</a>
                            ) : (
                                <a href={item.link} onClick={RenderMobileMenu.handleClickOutside}>{item.title}</a>
                            )}
                        </button>
                    </h2>
                </Accordion.Toggle>
            </Card>
        );
    });
}

function RenderMobileMenu() {
    const history = useHistory();
    const [isOpenMobileMenu, setOpenMobileMenu] = useState(false);

    const handleMobileMenu = (isOpen) => {
        setOpenMobileMenu(isOpen);
        hideApplicationScroll(isOpen);
    }

    RenderMobileMenu.handleClickOutside = () => {
        handleMobileMenu(false);
    }

    RenderMobileMenu.handleRedirectWithinMemberApp = (link) => {
        handleMobileMenu(false);
        history.push(link);
    }

    const handleOverlayClick = (e) => {
        if (e && e.target && e.target.id === "mobile-overlay") {
            handleMobileMenu(false);
        }
    }

    return (
        <NavDropdown
            data-testid="nav-top-mobile-menu"
            onToggle={handleMobileMenu}
            show={isOpenMobileMenu}
            title="Menu"
            id="mobile-menu-dropdown"
            className="mobileMenu"
        >
            <div data-testid="nav-child-mobile-menu" id="mobile-overlay" className="commonLoader show" onClick={(e) => { handleOverlayClick(e); }}>
                <Accordion className="astm-accordion astm-accordion--full-width">
                    {renderAccordian(navJSON)}
                </Accordion>
            </div>
        </NavDropdown>
    );
}

const clickOutsideConfig = {
    handleClickOutside: () => RenderMobileMenu.handleClickOutside
};

export default onClickOutside(RenderMobileMenu, clickOutsideConfig);
